import getEnvVar from '@/utils/getEnvVar';

export const COUNTRIES_WITH_HIDDEN_AI_BUTTON: ReadonlySet<string> = new Set(['DE', 'AT']);

export const AI_BUTTON_WHITELISTED_USER_IDS: ReadonlySet<string> = new Set(
  (getEnvVar('VITE_AI_BUTTON_WHITELISTED_USER_IDS') ?? '')
    .split(',')
    .map(userId => userId.trim().toLowerCase())
    .filter(Boolean),
);
